export default "__VITE_ASSET__DVrdGqy0__"